import { UserPermissions } from '@/types/user';
import { hasPermission } from '@/utils/userPermission';

/**
 * Permission gate on a nav entry. Mirrors the shape workspaceNavOptions already uses, pulled out
 * here so every section's nav definitions can be filtered the same way.
 */
export type NavPermissionRule =
  | { type: 'all'; requiredPermissions: string[] }
  | { type: 'single'; requiredPermission: string }
  | undefined;

export const passesPermissionRule = (
  rule: NavPermissionRule,
  permissions: UserPermissions | undefined
): boolean => {
  if (!rule) return true;

  if (rule.type === 'all') {
    return hasPermission({ permissions, requiredPermissions: rule.requiredPermissions });
  }

  return hasPermission({ permissions, requiredPermission: rule.requiredPermission });
};
